const MONTHS = [
  'JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE',
  'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER',
];

class DropTimer extends HTMLElement {
  connectedCallback() {
    this.closeDate = new Date(this.dataset.close);
    this.closedCopy = this.dataset.closedCopy || 'DROP CLOSED';
    this.tick();
    this.interval = setInterval(() => this.tick(), 60000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  formatCloseLabel() {
    const day = this.closeDate.getDate();
    const month = MONTHS[this.closeDate.getMonth()];
    const hours = String(this.closeDate.getHours()).padStart(2, '0');
    const minutes = String(this.closeDate.getMinutes()).padStart(2, '0');
    return 'DROP CLOSES ON ' + day + ' ' + month + ' ' + hours + ':' + minutes;
  }

  tick() {
    const now = new Date();
    const diff = this.closeDate.getTime() - now.getTime();

    if (Number.isNaN(diff)) {
      return;
    }

    if (diff <= 0) {
      this.textContent = this.closedCopy;
      if (this.interval) clearInterval(this.interval);
      return;
    }

    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);

    let countdown;
    if (days > 0) {
      countdown = days + ' DAYS LEFT';
    } else if (hours > 0) {
      countdown = hours + ' HOURS ' + minutes + ' MIN LEFT';
    } else {
      countdown = minutes + ' MIN LEFT';
    }

    this.textContent = countdown + ' - ' + this.formatCloseLabel();
  }
}

if (!customElements.get('drop-timer')) {
  customElements.define('drop-timer', DropTimer);
}
